import MainHeader from '@ifca-root/react-component/src/components/Header/MainHeader';
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper';
import {
	useDayEndFullReportLazyQuery,
	useGetOutletQuery,
	useGetReceiptPrinterQuery,
} from 'generated/graphql';
import React, { useContext, useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router';
import ReportViewer, { menuxReportUrl } from '../ReportViewer';
import Loading from '@ifca-root/react-component/src/components/Loading/Loading';
import {
	Box,
	Button,
	Grid,
	MenuItem,
	TextField,
	useMediaQuery,
} from '@material-ui/core';
import AppContext from 'containers/App/Store/AppContext';
import theme from '@ifca-root/react-component/src/assets/theme';
import { KeyboardDatePicker } from '@material-ui/pickers';
import CardContents from '@ifca-root/react-component/src/components/CardList/CardContents';
import { DynamicFooter } from 'components/Footer/DynamicFooter';
import { CommonDialog } from '@ifca-root/react-component/src/components/Dialog/CommonDialog';
import { printDayEndReportReceiptUSBPOS } from '../PosPrinter/DayEndReportReceipt/printDayEndReportReceiptUSBPOS';

export const DayEndReport = () => {
	const history = useHistory();
	const { outletID }: any = useParams();
	const user = JSON.parse(localStorage.getItem('loggedInUser'));
	const accountID = user.accountID;
	const loginID = user.ID;

	const {
		called: ouletCalled,
		loading: outletLoading,
		error: outletError,
		data: { getOutlet } = { getOutlet: [] },
	} = useGetOutletQuery({
		fetchPolicy: 'network-only',
		variables: { ID: outletID },
		onCompleted: () => {
			setFilterValue({
				...filterValue,
				outletID: outletID,
			});
		},
	});
	const outletArray: any[] = getOutlet;

	const {
		data: { getReceiptPrinter } = { getReceiptPrinter: [] },
		called: receiptPrinterCalled,
		loading: receiptPrinterLoading,
	} = useGetReceiptPrinterQuery({
		fetchPolicy: 'network-only',
		variables: { outletID: outletID, isDefault: true, orderByAsc: 'name' },
	});

	const [
		loadDayEndFullReport,
		{
			called: dayEndFullReportCalled,
			loading: dayEndFullReportLoading,
			data: dayEndFullReportData,
		},
	] = useDayEndFullReportLazyQuery({
		fetchPolicy: 'network-only',
		onCompleted: ({}) => {
			setLoadDayEnd(true);
		},
	});

	let reporturl =
		'DayEndReport' +
		'?accountid=' +
		accountID +
		'&outletid=' +
		outletID +
		'&loginid=' +
		loginID;
	// let reporturl =
	// 	'DailyEarningReport?accountid=' + accountID + '&outletid=' + outletID;

	const isPosGenericPrinter =
		getReceiptPrinter?.filter(x => x?.isDefault === true && x?.isSDK === false)
			?.length > 0
			? true
			: false;

	const isDesktop = useMediaQuery(theme.breakpoints.up('sm'), {
		defaultMatches: true,
	});
	const { globalState, dispatch }: any = useContext(AppContext as any);

	const date = new Date();
	//selectedStartDate
	const [selectedStartDate, setSelectedStartDate] = React.useState<Date | null>(
		date,
	);
	const handleStartDateChange = (date: Date | null) => {
		setSelectedStartDate(date);
	};
	const initialValue = {
		outletID:
			JSON.parse(localStorage.getItem('filterArgs'))?.outletID ??
			getOutlet[0]?.ID,
		date:
			JSON.parse(localStorage.getItem('filterArgs'))?.date ?? selectedStartDate,
		itemDetail:
			JSON.parse(localStorage.getItem('filterArgs'))?.itemDetail ?? false,
	};

	const [filterValue, setFilterValue] = useState(initialValue);
	const [connectedPrinter, setConnectedPrinter] = useState<any | null>(null);
	const [loading, setLoading] = useState(false);
	const [sendPrint, setSendPrint] = useState(false);
	const [openFilterDialog, setOpenFilterDialog] = useState(false);
	const [dayEnd, setLoadDayEnd] = useState(false);

	// Retrieve the printer data from localStorage
	useEffect(() => {
		const storedPrinter = getReceiptPrinter[0]?.deviceInfo;
		const isSDK = getReceiptPrinter[0]?.isSDK;

		if (
			openFilterDialog === true &&
			storedPrinter !== null &&
			isSDK === false
		) {
			connectToPrinter(storedPrinter);
		} else if (openFilterDialog === false && sendPrint === false) {
			// disconnectFromPrinter();
		} else if (openFilterDialog === false) {
			connectToPrinter(storedPrinter);
		}
		// if (storedPrinter !== null && isSDK === false) {
		// 	connectToPrinter(storedPrinter);
		// }
	}, [getReceiptPrinter[0]?.ID, sendPrint, openFilterDialog]);

	// Retrieve the printer data from localStorage
	useEffect(() => {
		if (dayEnd === true) {
			try {
				console.log('Calling printReceipt...');
				printDayEndReportReceiptUSBPOS(
					connectedPrinter,
					getOutlet[0],
					selectedStartDate,
					dayEndFullReportData?.dayEndFullReport?.daySalesSummary,
					dayEndFullReportData?.dayEndFullReport?.billDiscountCheckSummary,
					dayEndFullReportData?.dayEndFullReport?.paymentTypeSummaryV2,
					dayEndFullReportData?.dayEndFullReport?.mealPeriodSummary,
					dayEndFullReportData?.dayEndFullReport
						?.dayEndReportGetDiscountSummary,
					dayEndFullReportData?.dayEndFullReport?.paymentByUserSummary,
					dayEndFullReportData?.dayEndFullReport?.coverSummary,
					dayEndFullReportData?.dayEndFullReport?.coverByMealPeriodSummary,
					dayEndFullReportData?.dayEndFullReport?.menuItemSummary,
					dayEndFullReportData?.dayEndFullReport?.majorSummary,
					dayEndFullReportData?.dayEndFullReport?.familySummary,
					dayEndFullReportData?.dayEndFullReport?.billDetailSummary,
					dayEndFullReportData?.dayEndFullReport?.voidBillSummary,
					dayEndFullReportData?.dayEndFullReport?.billDiscountSummary,
					filterValue,
					getReceiptPrinter[0]?.deviceAlignmentCode,
				);
				console.log('Receipt printed and paper cut successfully!');
				console.log(
					'%cReceipt printed successfully!',
					'color: #12850b;',
					JSON.stringify(
						{
							productName: JSON.parse(localStorage.getItem('connectedPrinter'))
								?.productName,
							productId: JSON.parse(localStorage.getItem('connectedPrinter'))
								?.productId,
							vendorId: JSON.parse(localStorage.getItem('connectedPrinter'))
								?.vendorId,
						},
						null,
						'\t',
					),
				);
			} catch (error) {
				console.error('Failed to send data to the printer:', error);
				alert('Failed to print receipt!');
			} finally {
				// disconnectFromPrinter();
				setSendPrint(false);
				setLoading(false);
				setOpenFilterDialog(false);
				setLoadDayEnd(false);
			}
		}
	}, [dayEnd]);

	const connectToPrinter = async (printerData: any) => {
		try {
			setLoading(true);

			// Get the list of devices that match the vendorId and productId
			const devices = await navigator.usb.getDevices();
			const matchedDevice = devices.find(
				device =>
					device.vendorId === printerData.vendorId &&
					device.productId === printerData.productId,
			);

			if (matchedDevice) {
				console.log('Printer found:', matchedDevice);

				// Open the device and select configuration
				await matchedDevice.open();
				await matchedDevice.selectConfiguration(1);
				console.log('Configuration selected:', matchedDevice.configuration);

				if (
					!matchedDevice.configuration ||
					!matchedDevice.configuration.interfaces
				) {
					throw new Error('No interfaces found for this configuration');
				}

				const interfaces = matchedDevice.configuration.interfaces;
				console.log('Interfaces:', interfaces);

				// Claim the first interface
				await matchedDevice.claimInterface(0);
				console.log('Interface claimed');

				// Store the device object for later use
				setConnectedPrinter(matchedDevice);
				console.log('Printer connected successfully!');
			} else {
				console.error('Printer not found in the list of connected devices');
				console.error('No matching printer found');
			}
		} catch (err) {
			console.error('Error connecting to the printer:', err.message);
			console.error('Failed to connect to the printer');
		} finally {
			setLoading(false);
		}
	};

	const disconnectFromPrinter = async () => {
		if (!connectedPrinter) {
			console.warn('No printer is currently connected.');
			return;
		}

		try {
			setLoading(true);

			// Release the claimed interface (assuming 0 was claimed)
			await connectedPrinter.releaseInterface(0);
			console.log('Interface released');

			// Close the device
			await connectedPrinter.close();
			console.log('Printer disconnected successfully');

			// Clear the stored printer reference
			setConnectedPrinter(null);
		} catch (err) {
			console.error('Error disconnecting from the printer:', err.message);
		} finally {
			setLoading(false);
		}
	};

	const sendReceiptToPrinter = async () => {
		loadDayEndFullReport({
			variables: {
				outletID: outletID,
				date: selectedStartDate,
				itemDetail: filterValue?.itemDetail,
			},
		});
	};

	return (
		<>
			{outletLoading && <Loading />}
			{receiptPrinterLoading && <Loading />}
			{dayEndFullReportLoading && <Loading />}

			<MainHeader
				onClick={() =>
					history.push(`/menu/outlet-app/${outletID}/digital-reporting`)
				}
				mainBtn="back"
				smTitle="Business Insights"
				title={outletArray[0]?.name}
				routeSegments={[
					{ name: 'Business Insights' },
					{ name: 'Digital Reporting' },
					{ name: 'Day End Report', current: true },
				]}
			/>
			{isPosGenericPrinter === false ? (
				<ContentWrapper>
					{ReportViewer({
						url: reporturl,
						host: menuxReportUrl,
						// host: 'https://menuxdevreporting.ifca.asia',
						// host: 'http://localhost:61094/',
						// host: contractReportUrl,
						excludedExportFormat: [],
					})}
				</ContentWrapper>
			) : (
				<>
					<ContentWrapper>
						{ReportViewer({
							url: reporturl,
							host: menuxReportUrl,
							// host: 'https://menuxdevreporting.ifca.asia',
							// host: 'http://localhost:61094/',
							// host: contractReportUrl,
							excludedExportFormat: [],
						})}
					</ContentWrapper>
					<DynamicFooter
						options={[
							{
								name: 'POS Print',
								onClick: () => {
									setOpenFilterDialog(true);
								},
								// disabled: handlePermDisabled({
								// 	outletID: outletID,
								// 	permEnum: PosPermission.GeneralSettingRoundingPolicyUpdate,
								// }),
								color: 'primary',
								props: {
									type: 'submit',
								},
							},
						]}
					/>
					<CommonDialog
						fullWidth={true}
						open={openFilterDialog}
						onClose={() => setOpenFilterDialog(false)}
						sections={{
							header: {
								dynamic: (
									<div className="">
										<div className="dialog-dynamic-content">
											<div
												className="session"
												style={{
													display: 'flex',
													justifyContent: 'center',
													alignItems: 'center',
												}}
											>
												<div className="title flex-space">Day End Report</div>
											</div>
										</div>
									</div>
								),
							},
							body: () => (
								<form>
									<Box display="flex" width="100%">
										<TextField
											select
											label="Outlet Name"
											fullWidth
											value={getOutlet[0]?.ID ?? filterValue?.outletID ?? ''}
											margin="dense"
											name="outletID"
											disabled
											onChange={e => {
												setFilterValue({
													...filterValue,
													outletID: e.target.value,
												});
											}}
										>
											{getOutlet?.map((i, index) => (
												<MenuItem key={index} value={i.ID}>
													{i.name}
												</MenuItem>
											))}
										</TextField>
									</Box>
									<Box display="flex" width="100%">
										<Box pr="6px" width="50%">
											<KeyboardDatePicker
												value={selectedStartDate}
												margin="dense"
												autoOk
												label="Date"
												className="left date-icon"
												name="date"
												onChange={handleStartDateChange}
												format="dd/MM/yyyy"
												fullWidth
											/>
										</Box>

										<Box pr="6px" width="50%">
											<TextField
												select
												label="Item Detail"
												fullWidth
												className="right"
												value={filterValue?.itemDetail ?? ''} // fallback to empty string
												margin="dense"
												name="itemDetail"
												onChange={e => {
													setFilterValue({
														...filterValue,
														itemDetail: e.target.value === 'true', // converts string to boolean
													});
												}}
											>
												<MenuItem value="true">Yes</MenuItem>
												<MenuItem value="false">No</MenuItem>
											</TextField>
										</Box>
									</Box>
								</form>
							),
							footer: {
								actions: [
									{
										displayText: 'Cancel',
										props: {
											onClick: () => {
												setOpenFilterDialog(false);
											},
											variant: 'contained',
											color: 'primary',
										},
									},
									{
										displayText: 'Print',
										props: {
											onClick: () => {
												// onSubmit();
												sendReceiptToPrinter();
											},
											variant: 'contained',
											color: 'primary',
										},
									},
								],
							},
						}}
					/>
				</>
			)}
		</>
	);
};
